var _defs, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.28 71.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#21222c;}.cls-2{fill:#50a471;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.64,
    cy: 35.64,
    r: 35.64
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.88,48.54H19a1.46,1.46,0,0,1-1.45-1.46c0-1,0-14.22,0-20.53,0-2.38.62-3.79,3-3.79,4.57,0,22.09,0,29.06,0h1.55a2.44,2.44,0,0,1,2.46,2.44V46.73A1.81,1.81,0,0,1,51.88,48.54ZM22.6,25.69a16,16,0,0,0,1.66,1.38l.06,0,9,7.88.05,0,1.94,1.51a.92.92,0,0,0,1.17,0l11-9.75a6.77,6.77,0,0,0,1.22-1.06ZM25,45.56H46.36A.91.91,0,0,0,47,44L40.3,38.24a.91.91,0,0,0-1.24,0,4.67,4.67,0,0,1-3.35,1.77,4.8,4.8,0,0,1-3.41-1.77.92.92,0,0,0-1.24,0L24.41,44A.92.92,0,0,0,25,45.56Zm25.76-4.09V29.81a.92.92,0,0,0-1.51-.7l-7,5.77a.91.91,0,0,0,0,1.41l7,5.88A.91.91,0,0,0,50.77,41.47Zm-28.65.62L29,36.44A.92.92,0,0,0,29,35l-6.88-5.78a.92.92,0,0,0-1.51.7V41.39A.91.91,0,0,0,22.12,42.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailCircle);
export default __webpack_public_path__ + "static/media/mail-circle.4aefb39330e4687d929f3d3e182026c4.svg";
export { ForwardRef as ReactComponent };